import Application from "../../Application";
import LoginPresenter, {
  ILoginPresenter
} from "../../presenter/authentication/LoginPresenter";
import { UserPreferences, LanguageCodes } from "../../common/Constants";
import { ICredentialService } from "../../service/credential/CredentialService";

export default class ShowLoginInteractor {
  private application: Application;
  private output?: ILoginPresenter;
  private credentialService: ICredentialService;

  constructor({
    application,
    credentialService
  }: {
    application: Application;
    credentialService: ICredentialService;
  }) {
    this.application = application;
    this.credentialService = credentialService;
  }

  execute(lang?: string) {
    const language =
      lang && Object.values(LanguageCodes).includes(lang)
        ? lang
        : UserPreferences.DEFAULT_LANGUAGE;

    this.output = LoginPresenter({
      application: this.application,
      initialState: {
        username: "",
        password: "",
        loginButtonDisabled: true
      }
    });

    this.application.container.registerValue("language", language);
    this.credentialService.setLanguage(language);

    return this.output;
  }
}
